module.exports = __webpack_public_path__ + "img/dynamicsOfMachinery.8195b778.jpg";